import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // ✅ FIX: Stop infinite retries
      retry: 2, // Only retry twice instead of infinite
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      
      // ✅ FIX: Add timeout
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      
      // ✅ FIX: Refetch on errors
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      
      // ✅ FIX: Network mode
      networkMode: 'offlineFirst', // Try cache first if network fails
    },
  },
});
